import React from 'react';
import ItemPanel from '../ItemPanel';
import useUserStorePanel from './useUserStorePanel';
import { ISwitchOptions } from '../ItemPanel/types';

interface IUserStorePanel {
  onClose: () => void;
  onSelectStore: (storeId: string) => void;
  selectedStoreId?: string | undefined;
  panelTitle: string;
  renderStatus: (store: IPanelStore) => JSX.Element;
  loading?: boolean;
  allowedStoresFilter?: (store: IStore) => void;
  switchOptions?: ISwitchOptions<IPanelStore>;
}

const UserStorePanel = ({
  onClose,
  onSelectStore,
  selectedStoreId,
  panelTitle,
  renderStatus,
  loading,
  allowedStoresFilter = undefined,
  switchOptions,
}: IUserStorePanel) => {
  const { showLoader, mappedStores, mappedAdjacentStores, selectableQuery, handleSearch } =
    useUserStorePanel(loading, allowedStoresFilter, selectedStoreId);

  return (
    <ItemPanel
      switchOptions={switchOptions}
      items={mappedStores}
      featuredItems={mappedAdjacentStores}
      featuredItemsLabels={{ featured: 'Butiker nära dig', general: 'Alla butiker' }}
      onClose={onClose}
      onSelect={onSelectStore}
      selectedId={selectedStoreId}
      selectedOnTop
      title={panelTitle}
      searchLabel="Ange ditt postnummer, stad eller butiksnamn"
      selectableQuery={selectableQuery}
      multipleActions
      renderStatus={renderStatus}
      onSearch={handleSearch}
      noMatchText="Vi kunde tyvärr inte matcha någon butik med din sökfråga."
      loading={showLoader}
    />
  );
};

export default UserStorePanel;
